import { useQuery } from '@tanstack/react-query';

import { fetchChargeRates } from './rate-query.api';

export const useChargeRates = () => useQuery({ queryKey: ['rate-query', 'charges'], queryFn: () => fetchChargeRates(), staleTime: 60_000 });
